/**
 * 国际机票需求单类
 */
export default class InterNeedOrder {
  constructor(order = {}) {
    Object.assign(this, order)
  }
}